import React, { useEffect } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { DetailDrawer } from "./DetailDrawer";
import { useMarketingTypeModel } from "../allMemberMarketingTypeModel";

export function AllMemberMarketingType() {
    const {
        loadData,
        resetState,
        loadDs,
    } = useMarketingTypeModel()
    useEffect(() => {
        loadData({ pageNum: 1 }, {}).then()
        loadDs().then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

